/**
 * Hierarchy KPI JWT role strings — must match galloway-kpi-service AppUserContext.hasRole().
 *
 * Module entry (platform entitlement, see USER_ROLE.GOALS_AND_KPIS_VIEW in common.js):
 * - VIEW_GOALS_KPI — product entitlement only; pair with a visibility role below for sidebar/routes.
 *
 * QA / provisioning (Keycloak group "KPI Admin" / "Goals KPI Admin" is ops packaging only):
 * - KPI role groups should include VIEW_GOALS_KPI plus at least one visibility/layout role below.
 * - Goals KPI CEO group: VIEW_GOALS_KPI + VIEW_ALL_HIERARCHY + VIEW_CEO_DASHBOARD.
 * - VIEW_CEO_DASHBOARD is FE dashboard layout only — BE does not need to enforce it.
 * - KPI Admin group users should carry the admin hierarchy roles below on the token.
 * - Do NOT use SUPER_ADMIN (platform) or KPI_ADMIN (not provisioned) for company KPI admin.
 * - VIEW_ALL_HIERARCHY — org tree visibility (Goals/Hierarchy/Plans sidebar); not the CEO dashboard layout.
 * - VIEW_CEO_DASHBOARD — FE-only: selects the KPI CEO / executive dashboard widget layout.
 * - VIEW_CHAMPION_HIERARCHY — FE Approvals decide UI (progress/measure); not budget reallocations.
 * - VIEW_ALL_HIERARCHY grants tree visibility only — not full org audit (needs VIEW_ALL_HIERARCHY_AUDIT).
 * - Node assignments (PRIMARY, CO_OWNER, REVIEWER, APPROVER) are separate from these JWT flags.
 */
export const HIERARCHY_ROLES = {
  VIEW_ALL_HIERARCHY: "VIEW_ALL_HIERARCHY",
  VIEW_CEO_DASHBOARD: "VIEW_CEO_DASHBOARD",
  VIEW_DEPARTMENT_HIERARCHY: "VIEW_DEPARTMENT_HIERARCHY",
  VIEW_DIVISION_HIERARCHY: "VIEW_DIVISION_HIERARCHY",
  VIEW_ASSIGNED_HIERARCHY: "VIEW_ASSIGNED_HIERARCHY",
  VIEW_CHAMPION_HIERARCHY: "VIEW_CHAMPION_HIERARCHY",
  MANAGE_HIERARCHY_METADATA: "MANAGE_HIERARCHY_METADATA",
  MANAGE_HIERARCHY_ASSIGNMENTS: "MANAGE_HIERARCHY_ASSIGNMENTS",
  VIEW_ALL_HIERARCHY_AUDIT: "VIEW_ALL_HIERARCHY_AUDIT",
  // Backend's own permission for additional-parent link mutations (create/remove/edit weight) —
  // was missing from this catalogue entirely, so there was no way to check it client-side. 
  MANAGE_HIERARCHY_NODE_CONTENT: "MANAGE_HIERARCHY_NODE_CONTENT"
};

/** All hierarchy module roles — useful for QA checklists. */
export const HIERARCHY_ROLE_LIST = Object.values(HIERARCHY_ROLES);

export default HIERARCHY_ROLES;
